import React from 'react';
import { CBadge } from '@coreui/react-pro';
import { DISCOUNT_PERCENT, MarketingStatus } from '../../types/marketing';

export const formatCOP = (value: number) =>
    new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(value || 0);

// "2026-10-27 18:00:00" -> "2026-10-27T18:00" (input datetime-local)
export const toInputDate = (value?: string | null) => (value ? value.replace(' ', 'T').slice(0, 16) : '');

// Fecha legible en Colombia
export const formatDate = (value?: string | null) =>
    value
        ? new Date(value.replace(' ', 'T')).toLocaleString('es-CO', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })
        : '—';

// Ahora + días, para valores por defecto de los formularios
export const inputDateFromNow = (days: number) => {
    const date = new Date(Date.now() + days * 86400000);
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date.toISOString().slice(0, 16);
};

export const discountLabel = (discountTypesId: number, value: number) =>
    discountTypesId === DISCOUNT_PERCENT ? `${Number(value)}%` : formatCOP(value);

const STATUS_LABELS: Record<MarketingStatus, { label: string; className: string }> = {
    active: { label: 'Activo', className: 'text-success border-success-subtle bg-success-subtle' },
    scheduled: { label: 'Programado', className: 'text-info border-info-subtle bg-info-subtle' },
    finished: { label: 'Finalizado', className: 'text-body-secondary bg-body-tertiary' },
    inactive: { label: 'Pausado', className: 'text-warning border-warning-subtle bg-warning-subtle' },
};

export const StatusBadge: React.FC<{ status: MarketingStatus }> = ({ status }) => (
    <CBadge className={`border fw-normal px-2 py-1 ${STATUS_LABELS[status].className}`}>● {STATUS_LABELS[status].label}</CBadge>
);
